import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 left-0 z-50 h-screen w-screen bg-black/30 backdrop-blur transition-opacity duration-500"
}
const _hoisted_2 = {
  key: 0,
  class: "h-full transition-transform duration-500 ease-in-out"
}

import { ref } from 'vue';
import events from '@/events';


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignPopup',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as { id: string }


const open = ref(false);
const visible = ref(false);

events.$on('open-popup', onOpen);

function onOpen(id) {
    if (id === props.id) {
        open.value = true;
        setTimeout(() => {
            visible.value = true;
        }, 300);
        document.body.classList.toggle('overflow-hidden', true);
    }
}

function close() {
    visible.value = false;
    setTimeout(() => {
        open.value = false;
    }, 300);
    document.body.classList.toggle('overflow-hidden', false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_Transition, { name: "slide-left" }, {
                default: _withCtx(() => [
                  (visible.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default", { close: close })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})